import { registerQuery } from 'data-fetching-client';
import { getPreviewDomain } from 'invoices-ui-lib/api/PreviewDomainAPI';
export const FETCH_PREVIEW_DOMAIN = registerQuery({
  fieldName: 'previewDomain',
  fetcher: getPreviewDomain
});